<script lang="ts">
  export let width: number = 80;
  export let height: number = 80;
  export let className: string = "";
  // Font Awesome solid icon overlay
  export let rocketClass: string = "fa-solid fa-rocket";

  export let distanceText: string;

</script>

<div class="relative" style={`width:${width}px;height:${height}px;`}>
  <svg
    {width}
    {height}
    viewBox="0 0 80 80"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Around The Moon passport stamp"
    class={className}
  >
    <title>Around The Moon Passport Stamp</title>

    <defs>
      <!-- Circular path for full text wrap -->
      <path id="textCircle" d="M 40 40 m -30,0 a 30,30 0 1,1 60,0 a 30,30 0 1,1 -60,0" pathLength="100" />
    </defs>

    <!-- Outer crater coin rim -->
    <circle cx="40" cy="40" r="38" fill="none" stroke="#000" stroke-width="1.8" />

    <!-- Inner thin rule -->
    <circle cx="40" cy="40" r="28" fill="none" stroke="#000" stroke-width="0.9" opacity="0.95" />

    <!-- Bead scallops for passport texture -->
    <circle cx="40" cy="40" r="26" fill="none" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-dasharray="0.4 4" opacity="0.85" />

    <!-- Crater dents on the rim (short arcs) -->
    <!-- <g stroke="#000" stroke-width="1.2" stroke-linecap="round" opacity="0.85">
      <path d="M 62 10 A 2 2 0 0 1 66 12" />
      <path d="M 14 20 A 2 2 0 0 1 16 24" />
      <path d="M 68 58 A 2 2 0 0 1 70 62" />
      <path d="M 20 64 A 2 2 0 0 1 24 66" />
    </g> -->

    <!-- Lunar surface panel (low opacity) -->
    <circle cx="40" cy="40" r="28" fill="#000" opacity="0.08" />
    <!-- Minimal crater marks inside -->
    <g fill="#000" stroke="#000">
      <circle cx="30" cy="32" r="3" fill="#000" opacity="0.18" />
      <circle cx="48" cy="44" r="2.5" fill="#000" opacity="0.18" />
      <circle cx="42" cy="30" r="2" fill="#000" opacity="0.18" />
      <circle cx="36" cy="48" r="1.8" fill="#000" opacity="0.18" />
      <circle cx="56" cy="30" r="2.2" fill="#000" opacity="0.18" />
      <circle cx="23" cy="50" r="2.4" fill="#000" opacity="0.18" />
      <circle cx="40" cy="54" r="1.9" fill="#000" opacity="0.18" />
      <circle cx="40" cy="22" r="2.1" fill="#000" opacity="0.18" />
      <circle cx="52" cy="52" r="2.7" fill="#000" opacity="0.18" />
    </g>

    <!-- Curved text going around the inner ring (normalized to full circle) -->
    <text fill="#000" font-size="7.8" font-weight="500" text-anchor="start" lengthAdjust="spacingAndGlyphs" textLength="185" style="paint-order: stroke fill; stroke: #000; stroke-width: 0.5;">
      <textPath href="#textCircle" startOffset="0">AROUND THE MOON • AROUND THE MOON •</textPath>
    </text>

    <!-- Central distance text -->
    <g transform="translate(40,40)">
      <text x="0" y="3" fill="#000" font-size="9" font-weight="700" text-anchor="middle">{distanceText}</text>
    </g>
  </svg>

  <!-- Font Awesome rocket overlay, top-right outside the moon -->
  <div class="absolute" style="top:-4px;right:-4px;color:#000;">
    <i class={rocketClass} style="font-size:16px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
</div>
